import { browserStorageKeyType } from '../constants/browserStorageKeys/browserStorageKeys.constant';

type browserStorageType = 'localStorage' | 'sessionStorage';

const storage = {
  localStorage: window.localStorage,
  sessionStorage: window.sessionStorage,
};

interface ISetItemToBrowserStorageParams {
  storageType: browserStorageType;
  itemKey: browserStorageKeyType;
  value: string;
}

const setItemToBrowserStorage = ({ storageType, itemKey, value }: ISetItemToBrowserStorageParams) => {
  storage[storageType].setItem(itemKey, value);
};

interface IGetItemFromBrowserStorageParams {
  storageType: browserStorageType;
  itemKey: browserStorageKeyType;
}

const getItemFromBrowserStorage = ({ storageType, itemKey }: IGetItemFromBrowserStorageParams) => {
  return storage[storageType].getItem(itemKey);
};

export const browserStorage = {
  getItem: getItemFromBrowserStorage,
  setItem: setItemToBrowserStorage,
};
